import { render, staticRenderFns } from "./d-title-bg.vue?vue&type=template&id=b9de4d34&scoped=true"
import script from "./d-title-bg.vue?vue&type=script&lang=js"
export * from "./d-title-bg.vue?vue&type=script&lang=js"
import style0 from "./d-title-bg.vue?vue&type=style&index=0&id=b9de4d34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9de4d34",
  null
  
)

export default component.exports